export const cadastroGeral = {
  steps: [
    {
      name: "Cadastro Geral",
      fields: [
        { field: "name", translated: "Nome" },
        { field: "email", translated: "Email" },
        { field: "document", translated: "CPF" },
        { field: "birthday", translated: "Data de Nascimento" },
        { field: "state", translated: "Estado" },
        { field: "counties", translated: "Cidade" },
        { field: "community", translated: "Comunidade" },
        { field: "address", translated: "Endereço" },
        { field: "phone", translated: "Telefone" },
        { field: "whatsapp", translated: "Whatsapp" },
      ],
    }
  ],
}